const JSON_LD_ID = "page-json-ld";

export function setMetaTag(
  attribute: "name" | "property",
  key: string,
  content: string,
): void {
  let element = document.head.querySelector<HTMLMetaElement>(
    `meta[${attribute}="${key}"]`,
  );

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

export function removeMetaTag(attribute: "name" | "property", key: string): void {
  document.head.querySelector(`meta[${attribute}="${key}"]`)?.remove();
}

export function setLinkTag(rel: string, href: string): void {
  let element = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);

  if (!element) {
    element = document.createElement("link");
    element.rel = rel;
    document.head.appendChild(element);
  }

  element.href = href;
}

export function removeLinkTag(rel: string): void {
  document.head.querySelector(`link[rel="${rel}"]`)?.remove();
}

export function setJsonLd(data: Record<string, unknown> | Record<string, unknown>[]): void {
  let script = document.getElementById(JSON_LD_ID) as HTMLScriptElement | null;

  if (!script) {
    script = document.createElement("script");
    script.id = JSON_LD_ID;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }

  script.textContent = JSON.stringify(data);
}

export function removeJsonLd(): void {
  document.getElementById(JSON_LD_ID)?.remove();
}
